// extracted by mini-css-extract-plugin
export default {"full_box":"style_full_box__2KHEf"};